export function statusChangeToError(message, statusChange) {
  const error = new Error(message);
  if (statusChange.reason) {
    error.responseText = statusChange.reason.toString();
  }
  return error;
}